/**
 * 採用ページ 下部追従バナー
 * 初期状態は非表示。一定量スクロールしたら表示する。
 */
const recruitFloating = () => {
    const floating = document.querySelector('.pg-recruit-floating');
    if (!floating) return;

    // 「少しスクロールしたら」の閾値
    const THRESHOLD = 300;

    const update = () => {
        floating.classList.toggle('is-hidden', window.scrollY < THRESHOLD);
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
};

export default recruitFloating;
